import axios from 'axios'
import storage from '@/utils/storage'
import { Toast } from 'vant'

// 创建axios实例
const API_BASE2 = (process.env.VUE_APP_API_BASE || '/springboot6hv37').replace(/\/$/, '') + '/'
const service = axios.create({
  baseURL: API_BASE2,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

// request拦截器
service.interceptors.request.use(
  config => {
    const token = storage.get('Token')
    if (token) {
      config.headers['token'] = token
    }
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

// response拦截器
service.interceptors.response.use(
  response => {
    if (response.data && response.data.code === 401) {
      Toast.fail('登录已过期，请重新登录')
      storage.remove('Token')
      window.location.href = '/coach/login'
      return Promise.reject(new Error('登录已过期'))
    }
    return response
  },
  error => {
    console.log('err' + error)
    let message = error.message || '网络错误'
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 400:
          message = '请求错误'
          break
        case 401:
          message = '未授权，请重新登录'
          storage.remove('Token')
          window.location.href = '/coach/login'
          break
        case 403:
          message = '拒绝访问'
          break
        case 404:
          message = '请求地址出错'
          break
        case 408:
          message = '请求超时'
          break
        case 500:
          message = '服务器内部错误'
          break
        case 501:
          message = '服务未实现'
          break
        case 502:
          message = '网关错误'
          break
        case 503:
          message = '服务不可用'
          break
        case 504:
          message = '网关超时'
          break
        case 505:
          message = 'HTTP版本不受支持'
          break
        default:
          break
      }
    }
    Toast.fail(message)
    return Promise.reject(error)
  }
)

export default service 